export const municipiosEndpoint = {
    // Municípios
    listarMunicipios: `/api/v1/basicos/municipios`,
    obterPorDescricao: (descricao) => `/api/v1/basicos/municipios/${descricao}`,
}
